export default class Market {
  static async list() {
    return fetch(`${process.env.REACT_APP_API_URL}/markets`).then(res =>
      res.json()
    )
  }
}